export const SET_HAMBURGER_MENU_STATE = 'SET_HAMBURGER_MENU_STATE';
export const SET_MAIN_MENU_LIST = 'SET_MAIN_MENU_LIST';
export const SET_DAR_REPORTS_FILTERS = "SET_DAR_REPORTS_FILTERS";
export const RESET_DAR_REPORTS_FILTERS = "RESET_DAR_REPORTS_FILTERS";